// 제목 글자를 단어 단위로 감싼다: <span class="ib-w"><span class="ib-wi">단어</span></span>
// <br>, 색 강조용 <span>, <em> 같은 안쪽 태그는 그대로 두고 그 안의 글자만 나눈다.
// 같은 제목에 두 번 실행해도 한 번만 나눈다.
export function splitWords(el) {
  if (!el || el.dataset.ibSplit) return;
  el.dataset.ibSplit = "1";
  let wi = 0;
  const walk = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const parts = child.textContent.split(/(\s+)/);
        if (!parts.some((p) => p.trim())) return;
        const frag = document.createDocumentFragment();
        parts.forEach((p) => {
          if (!p) return;
          if (!p.trim()) {
            frag.appendChild(document.createTextNode(p));
            return;
          }
          const w = document.createElement("span");
          w.className = "ib-w";
          const inner = document.createElement("span");
          inner.className = "ib-wi";
          inner.textContent = p;
          inner.style.setProperty("--wi", String(wi++));
          w.appendChild(inner);
          frag.appendChild(w);
        });
        node.replaceChild(frag, child);
      } else if (child.nodeType === Node.ELEMENT_NODE && !["BR", "SVG", "IMG"].includes(child.tagName.toUpperCase())) {
        walk(child);
      }
    });
  };
  walk(el);
  el.classList.add("ib-split");
}
